<template>
<div class="chapter">
<div class="inner_page">
<div class="fmtitle"><a id="page_vii"></a>Contents</div>
<div class="toc" style="margin-top:0em;"><a href="#/preface" id="preface">Preface</a></div>
<div class="toc"><a href="#/notetothereader" id="rnotetothereader">Note to the Reader</a></div>
<div class="toc"><a href="#/introduction" id="intro">Introduction</a></div>
<div class="toc"><a href="#/ch01" id="ch01">1. Porter and Mexican Politics</a></div>
<div class="toc"><a href="#/ch02" id="ch02">2. Porter in Mexico, 1920–1921</a></div>
<div class="toc"><span href="#/ch03" id="ch03" title="Link target outside of Sample">3. Porter and Mexican Art, 1922 and 1923</span></div>
<div class="toc"><span href="#/ch04" id="ch04" title="Link target outside of Sample">4. Thinking of Mexico, 1924–1930</span></div>
<div class="toc"><span href="#/ch05" id="ch05" title="Link target outside of Sample">5. Mexico Once More, 1930–1931</span></div>
<div class="toc"><span href="#/ch06" id="ch06" title="Link target outside of Sample">6. Becoming Miranda</span></div>
<div class="toc"><span href="#/ch07" id="ch07" title="Link target outside of Sample">7. <i>Ship of Fools</i></span></div>
<div class="toc"><span href="#/conclusion" id="con" title="Link target outside of Sample">Conclusion</span></div>
<div class="toc"><span href="#/notes" id="notes" title="Link target outside of Sample">Notes</span></div>
<div class="toc"><span href="#/bibliography" id="bib" title="Link target outside of Sample">Bibliography</span></div>
<div class="toc"><span href="#/index" id="index" title="Link target outside of Sample">Index</span></div>
<div class="toc"><span href="#/acknowledgments" id="ack" title="Link target outside of Sample">Permissions Acknowledgments</span></div>
<div class="toc1"><span href="#/photos#rphoto1" id="photo1" title="Link target outside of Sample">Photographs</span><a id="page_viii"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?09dbb9ee